export default __webpack_public_path__ + "static/media/login-bg.4c49b6dd.svg";